import VHover from './VHover';
export { VHover };
export default VHover;
//# sourceMappingURL=index.js.map